export interface NavbarLinkData {
  id: number
  name: string
  href: string
}

export const midNavbarLinkListData: NavbarLinkData[] = [
  {
    id: 1,
    name: "Products",
    href: "#",
  },
  {
    id: 2,
    name: "Services",
    href: "#",
  },
  {
    id: 3,
    name: "Pricing",
    href: "#",
  },
  {
    id: 4,
    name: "Testimonials",
    href: "#",
  },
  {
    id: 5,
    name: "Blog",
    href: "#",
  },
]
